import { VALIDATE_CONTRACT_AGENT } from "./types";

export const validContractAgent = value => async dispatch => {
  try {
    dispatch({ type: VALIDATE_CONTRACT_AGENT, payload: value });
  } catch (e) {}
};
